import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { SavedViewKind } from '@platform/core/types';
import type { IViewKindPickerProps } from './IViewKindPickerProps';

const KINDS: readonly SavedViewKind[] = ['any', 'table', 'board', 'cards'];

/** «Тип подання» (прототип v4): сегментований вибір «Усі подання · Таблиця · Дошка · Картки» (30px) і підказка, що відкриває вибір. */
export function ViewKindPicker({ kind, onChange }: IViewKindPickerProps) {
  const { t } = useTranslation();
  return (
    <div className="lv-vs__field">
      <span className="lv-vs__caption">{t('viewSettings.type')}</span>
      <div className="lv-vs__kinds" role="radiogroup" aria-label={t('viewSettings.type')}>
        {KINDS.map((k) => (
          <button key={k} type="button" role="radio" aria-checked={k === kind} className={cx('lv-vs__kind', k === kind && 'is-on')} onClick={() => onChange(k)}>
            {t(`viewSettings.kinds.${k}`)}
          </button>
        ))}
      </div>
      <span className="lv-vs__hint">{t(`viewSettings.hint.${kind}`)}</span>
    </div>
  );
}
